export default {
  dashboard: null,
  dashboardNameToCreate: '',
  dashboardDeletionPending: [],
  dashboardCreationPending: false
}
